import { render } from "./DocumentCard.vue?vue&type=template&id=a4931e96&scoped=true"
import script from "./DocumentCard.vue?vue&type=script&lang=js"
export * from "./DocumentCard.vue?vue&type=script&lang=js"

import "./DocumentCard.vue?vue&type=style&index=0&id=a4931e96&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4931e96"]])

export default __exports__